import { css } from '@emotion/react'
import { CloseIcon } from '@ruguoapp/jike-fe-icons'
import type { ReactNode } from 'react'
import LoadableUserList, { type LoadableUserListProps } from './LoadableUserList'
import Modal from './Modal'

export interface UserListModalProps extends Omit<LoadableUserListProps, 'title'> {
	isShow: boolean
	onShowChange: (next: boolean) => void
	title: ReactNode
}

export default function UserListModal({
	isShow,
	onShowChange,
	title,
	...props
}: UserListModalProps) {
	return (
		<Modal
			isShow={isShow}
			onClose={() => onShowChange(false)}
			header={
				<>
					<div
						css={css`
							display: flex;
							width: fit-content;
							cursor: pointer;
						`}
						onClick={() => onShowChange(false)}
					>
						<CloseIcon
							css={css`
								width: 24px;
								aspect-ratio: 1;
							`}
						/>
					</div>
					<div
						css={css`
							justify-content: center;
							color: var(--tint-primary, #333);
							text-align: center;
							font-size: 20px;
							font-weight: 500;
							line-height: 28px;
						`}
					>
						{title}
					</div>
					<div />
				</>
			}
			css={css`
				.jk-modal-container {
					overflow: hidden;
					margin-top: 5%;
					height: fit-content;
					width: 648px;
				}
			`}
		>
			<LoadableUserList
				{...props}
				css={css`
					padding: 0 16px 20px;
					height: 100%;
					overflow-y: auto;
				`}
			/>
		</Modal>
	)
}
